<template>
  <div class="counter d-flex align-items-center" :class="{ small: small }">
    <button class="counter__decrement me-3" @click="handleDec">-</button>
    <div contenteditable="true" type="number" @input="onInput">
      {{ count }}
    </div>
    <button class="counter__increment ms-3" @click="handleInc">+</button>
  </div>
</template>

<script setup>
  import { defineProps } from 'vue';

  const props = defineProps({
    count: Number,
    countInc: Function,
    countDec: Function,
    addToCart: Function,
    small: Boolean,
  });

  const handleInc = () => {
    const nextValue = Number(props.count) + 1;
    props.countInc();
    props.addToCart(nextValue);
  };

  const handleDec = () => {
    if (props.count > 1) {
      const nextValue = Number(props.count) - 1;
      props.countDec();
      props.addToCart(nextValue);
    }
  };

  const onInput = (e) => {
    const sanitizedValue = e.target.innerText.replace(/[^0-9]/g, '');
    const num = Number(sanitizedValue);

    if (sanitizedValue !== '' && !isNaN(num) && num > 0) {
      props.addToCart(num);
    }
  };
</script>
